module.exports = __webpack_public_path__ + "static/media/user.active.9bcb9c93.svg";